import { useState, useEffect } from "react";

const KEY = "mb_currency";
export const SYMBOLS = { GBP: "£", EUR: "€", USD: "$" };
const DEFAULTS = { code: "GBP", rates: { GBP: 12.3, EUR: 10.5, USD: 9.3 } };

export function loadCurrency() {
  try {
    const r = JSON.parse(localStorage.getItem(KEY));
    if (r && r.rates) return { code: r.code || "GBP", rates: { ...DEFAULTS.rates, ...r.rates } };
  } catch (e) { console.error("Stored currency settings unreadable, using defaults", e); }
  return DEFAULTS;
}

// MAD per 1 unit of currency (e.g. 12.3 MAD = £1)
export function useCurrency() {
  const [cur, setCur] = useState(loadCurrency);
  useEffect(() => { localStorage.setItem(KEY, JSON.stringify(cur)); }, [cur]);

  const setCode = (code) => setCur((c) => ({ ...c, code }));
  const setRate = (code, val) => setCur((c) => ({ ...c, rates: { ...c.rates, [code]: Number(val) || 0 } }));

  const symbol = SYMBOLS[cur.code] || "£";
  const rate = cur.rates[cur.code] || 1;
  const convert = (mad) => (rate > 0 ? (mad || 0) / rate : 0);
  const fmt = (mad) => `${symbol}${Math.round(convert(mad)).toLocaleString()}`;

  return { cur, setCode, setRate, symbol, rate, convert, fmt };
}
